module.exports = __webpack_public_path__ + "static/media/BAL.b734dfe2.svg";